import React, { ReactElement } from "react";
import { Box, Menu } from "@chakra-ui/react";
import {
  DASHBOARD,
  UNPROCESSED_EMAILS,
  PROCESSED_EMAILS,
  EMAILS_FOR_REVIEW,
  FAILED_EMAILS,
  SETTINGS_PROFILE,
  SETTINGS_LOGS,
} from "@/constants/routes";
import DashBlackIcon from "@/assets/DashblackIcon.svg";
import DashWhiteIcon from "@/assets/DashwhiteIcon.svg";
import UnprBlackIcon from "@/assets/UnprBlIcon.svg";
import UnprWhIcon from "@/assets/UnpWhIcon.svg";
import ProcBlIcon from "@/assets/ProcBlIcon.svg";
import ProcWhIcon from "@/assets/ProcWhIcon.svg";
import ReviewBlIcon from "@/assets/ReviewBlIcon.svg";
import ReviewWhIcon from "@/assets/ReviewWhIcon.svg";
import FailedBlIcon from "@/assets/FailedBlIcon.svg";
import FailedWhIcon from "@/assets/FailedWhIcon.svg";
import SettingsBlIcon from "@/assets/SettingBlIcon.svg";
import SettingsWhIcon from "@/assets/SettingWhIcon.svg";
import { CgProfile } from "react-icons/cg";
import { TbLogs } from "react-icons/tb";
import NavItem from "./NavItem";

export interface NavLink {
  path?: string;
  title: string;
  icon?: string;
  iconContrast?: string;
  iconEl?: ReactElement;
  subselections?: NavLink[];
}

const NAV_LINKS_MAPPER: NavLink[] = [
  {
    path: DASHBOARD,
    title: "Dashboard",
    icon: DashBlackIcon,
    iconContrast: DashWhiteIcon,
  },
  {
    path: UNPROCESSED_EMAILS,
    title: "Unprocessed Apps",
    icon: UnprBlackIcon,
    iconContrast: UnprWhIcon,
  },
  {
    path: PROCESSED_EMAILS,
    title: "Processed Apps",
    icon: ProcBlIcon,
    iconContrast: ProcWhIcon,
  },
  {
    path: EMAILS_FOR_REVIEW,
    title: "Apps for Review",
    icon: ReviewBlIcon,
    iconContrast: ReviewWhIcon,
  },
  {
    path: FAILED_EMAILS,
    title: "Failed Apps",
    icon: FailedBlIcon,
    iconContrast: FailedWhIcon,
  },
];

const SETTINGS_MAPPER: NavLink[] = [
  {
    title: "Settings",
    icon: SettingsBlIcon,
    iconContrast: SettingsWhIcon,
    subselections: [
      {
        title: "Profile",
        path: SETTINGS_PROFILE,
        iconEl: <CgProfile size={20} />,
      },
      { title: "Logs", path: SETTINGS_LOGS, iconEl: <TbLogs size={20} /> },
    ],
  },
];

const Sidenav = ({ width = 270 }: { width?: number }) => {
  return (
    <Box
      w={{ base: "fit-content", xl: `${width}px` }}
      h="calc(100vh - var(--headerHeight))"
      bg="bg.panel"
      overflowX="hidden"
      display="flex"
      flexDirection="column"
    >
      <Menu.Root>
        <hr color="black" />
        <Box mt="60px" flex={1} width="100%">
          {NAV_LINKS_MAPPER.map((item, index) => (
            <NavItem item={item} key={index} />
          ))}
        </Box>
        <Menu.Separator />
        <Box height={width} width="100%">
          {SETTINGS_MAPPER.map((item, index) => (
            <NavItem item={item} key={index} />
          ))}
        </Box>
      </Menu.Root>
    </Box>
  );
};

export default Sidenav;
